<template>
  <div class="container article">
    <div class="">
      <div style="fontWeight:700;color:rgba(0,0,0,0.9)">笔记管理-评论</div>
      <div class="content">
        <div class="left">

        </div>
      </div>
    </div>
    <div class="filters card">
      <el-form class="search-wrap"
               ref="searchForm"
               :inline="true"
               :model="query">
        <!-- <el-form-item label="评论内容"
                      prop="order_no">
          <el-input v-model.trim="query.order_no"
                    placeholder="输入评论内容"
                    @input="fetchCommentList(true)"
                    clearable
                    style="width:200px;"></el-input>
        </el-form-item> -->

        <el-form-item label="评论分组"
                      prop="order_no">
          <el-select v-model="query.category_ids"
                     placeholder="请选择"
                     clearable
                     filterable
                     @change="fetchCommentList(true)"
                     style="width:150px;">
            <el-option v-for="item in filter.group"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>

      <div class="right">
        <el-button type="primary"
                   @click="handleCreate()">新建</el-button>
        <el-button type="primary"
                   @click="handleGroup()">分组</el-button>
      </div>
    </div>
    <div class="results card">
      <div class="table-header">
        <h3 class="title">评论列表</h3>
      </div>
      <div class="values">
        <el-table :data="results"
                  border
                  style="width: 100%"
                  @selection-change="handleSelectionChange">
          <el-table-column type="selection"
                           width="50"
                           align="center"> </el-table-column>
          <el-table-column type="index"
                           label="序号"
                           width="90"
                           align="center">
          </el-table-column>

          <el-table-column prop="category_name"
                           width="120"
                           label="分组"
                           align="center"
                           show-overflow-tooltip>

          </el-table-column>
          <el-table-column prop="content"
                           label="评论内容"
                           align="left"
                           show-overflow-tooltip>

          </el-table-column>

          <el-table-column label="创建日期"
                           align="center"
                           width="160"
                           show-overflow-tooltip>
            <template slot-scope="scope">
              {{
                scope.row.create_time
                  ? $moment(scope.row.create_time).format("YYYY-MM-DD HH:mm")
                  : ""
              }}
            </template>
          </el-table-column>
          <el-table-column label="修改日期"
                           align="center"
                           width="160"
                           show-overflow-tooltip>
            <template slot-scope="scope">
              {{
                scope.row.update_time
                  ? $moment(scope.row.update_time).format("YYYY-MM-DD HH:mm")
                  : ""
              }}
            </template>
          </el-table-column>
          <el-table-column label="操作"
                           align="center"
                           width="90"
                           fixed="right">
            <template slot-scope="scope">
              <el-link type="primary"
                       :underline="false"
                       @click="goEdit(scope.row)">编辑</el-link>
              <!-- <el-link type="danger"
                       @click="goDelte(scope.row.id)"
                       :underline="false">删除</el-link> -->
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="footer">
        <div class="left">
          <span>已选0条</span>
          <span class="xian"></span>
          <span style="marginRight:16px">批量</span>
          <p class="batch"
             @click="goDelte()">删除</p>

        </div>
        <el-pagination background
                       layout="total, prev, pager, next, sizes, jumper"
                       :current-page="Number(query.pageIndex)"
                       :page-sizes="[10, 20, 50, 100, 500]"
                       :page-size="Number(query.pageSize)"
                       :total="Number(pageTotal)"
                       @size-change="handleSizeChange"
                       @current-change="handlePageChange"></el-pagination>
      </div>
    </div>
    <!-- 新建评论 -->
    <CreateComment :visible="commentVisible"
                   :detailRow="detailRow"
                   :title="title"
                   @close="commentClose()" />
    <!-- 分组 -->
    <RandomGroupComment :visible="groupVisible"
                        :detailRow="detailRow"
                        @close="groupClose()" />
  </div>
</template>

<script>
import { materialList, Deletematerial } from '@/api/note'
import CreateComment from '@/components/dialog/randomCreateComment/index'
import RandomGroupComment from '@/components/dialog/randomGroupComment/index'

export default {
  components: { CreateComment, RandomGroupComment },
  data() {
    return {
      commentVisible: false,
      groupVisible: false,
      query: {
        pageIndex: 1,
        pageSize: localStorage.getItem('pageSize')
          ? Number(localStorage.getItem('pageSize'))
          : 10,
        category_ids: [],
      },
      pageTotal: 10,
      filter: {
        group: [
          { label: '通用', value: '1' },
          { label: '经验', value: '2' },
          { label: '资料', value: '3' },
          { label: '视频', value: '4' },
          { label: '解答', value: '5' },
        ],
      },
      results: [],
      title: '',
      detailRow: {},
      chooseList: [],
    }
  },
  created() {
    this.fetchCommentList()
  },

  methods: {
    handleSelectionChange(val) {
      this.chooseList = val
    },
    fetchCommentList(reset) {
      if (reset) {
        this.query.pageIndex = 1
      }
      materialList(this.query).then((res) => {
        this.results = res.list
        this.pageTotal = res.count
        console.log('res', res)
      })
    },
    handleCreate() {
      this.title = '新建评论'
      this.commentVisible = true
    },
    handleGroup() {
      this.groupVisible = true
    },
    // 分页条数变化
    handleSizeChange(val) {
      this.$set(this.query, 'pageSize', val)
      localStorage.setItem('pageSize', val)
      this.fetchCommentList()
    },
    // 分页导航
    handlePageChange(val) {
      this.$set(this.query, 'pageIndex', val)
      this.fetchCommentList()
    },
    commentClose() {
      this.commentVisible = false
      this.fetchCommentList()
    },
    groupClose() {
      this.groupVisible = false
      this.fetchCommentList()
    },
    goEdit(item) {
      this.title = '编辑评论'
      this.detailRow = item
      this.commentVisible = true
    },
    goDelte(item) {
      if (this.chooseList.length == 0) {
        this.$message.error('请选择数据!')
        return
      }
      this.$confirm('确定要删除这条信息吗', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        let data = {
          ids: [],
        }
        this.chooseList.map((item) => {
          data.ids.push(item.id)
        })
        Deletematerial(data).then((res) => {
          this.$message.success(`删除成功`)
          this.fetchCommentList()
        })
      })
    },
  },
}
</script>

<style scoped lang="less">
.article {
  .card {
    position: relative;
    color: #303133;
    background-color: #fff;
    border: 1px solid #ebeef5;
    // box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
    border-radius: 4px;
    overflow: hidden;
    padding: 20px;
  }
  .table-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 101%;
    height: 40px;
  }
  .header {
    .breadcrumb {
      margin-bottom: 30px;
    }
    .title {
      font-size: 30px;
    }
    .content {
      display: flex;
      align-content: center;
      overflow-y: visible;
    }

    .left,
    .right {
      flex: 1;
    }
    .right {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      text-align: center;

      .button {
        // font-size: 14px;
        // padding: 12px 20px;
      }
    }
  }

  .filters {
    margin-top: 20px;
    display: flex;
    justify-content: space-between;

    .search-wrap {
      margin-bottom: -18px;

      .datetime {
        width: 380px;
      }

      /deep/ .el-radio-button__orig-radio:checked + .el-radio-button__inner {
        color: #409eff;
        background: #ecf5ff;
        border-color: #b3d8ff;
        box-shadow: none !important;
      }
    }
    .divider {
      border-bottom: 1px dashed #dcdfe6;
      margin: 15px 0;
    }
    .search-footer {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .action-wrap {
      display: flex;
      justify-content: flex-end;
    }

    .filter-item {
      display: flex;

      .label {
        line-height: 32px;
        margin-right: 10px;
      }
      .values {
        display: flex;
        flex-wrap: wrap;
        flex: 1;
      }
      .value-item {
        height: 32px;
        line-height: 32px;
        border-radius: 4px;
        padding: 0 10px;
        margin-right: 5px;
        cursor: pointer;

        &.active {
          color: #fff;
          background: #409eff;
        }
      }
    }
  }
  .results {
    margin-top: 10px;
    padding-right: 32px;

    .title {
      font-size: 20px;
      font-weight: bold;
      margin-bottom: 20px;
    }
    .values {
      display: flex;
      flex-wrap: wrap;
      margin-right: -15px;
    }
    .material-item {
      margin-right: 15px;
      margin-bottom: 15px;
    }
    .footer {
      display: flex;
      justify-content: space-between;
      margin-top: 20px;
      .left {
        cursor: pointer;
        display: flex;
        align-items: center;
        .xian {
          margin-left: 16px;
          margin-right: 16px;
          width: 1px;
          height: 20px;
          background: #dcdfe6;
          border-radius: 0px 0px 0px 0px;
        }
        .batch {
          text-align: center;
          line-height: 26px;
          width: 46px;
          height: 26px;
          border-radius: 4px 4px 4px 4px;
          border: 1px solid #f56c6c;
          font-weight: 400;
          font-size: 13px;
          color: #f56c6c;
        }
      }
    }
    .el-link {
      margin: 0 8px;
    }
    .item-table-column {
      text-align: left;
    }
  }
  .el-dropdown-link {
    cursor: pointer;
    color: #409eff;
  }
}
.tag-wrap {
  text-align: left;
  width: 100%;
  min-height: 30px;
}
.el-tag {
  margin: 0px 5px;
}
</style>
